import sizeTypes from "./constants/sizeTypes";

export default function translateVariantSize(sizeType, size, tCommon, sizeReference = "") {
  switch (sizeType) {
    case sizeTypes.size_tu:
    case sizeTypes.size_multiple:
    case undefined:
      return tCommon("unique_size");
    case sizeTypes.size_pants:
      return size;
    case sizeTypes.size_fr:
      return tCommon(`size_display_converter.${sizeType}.${sizeReference}.${size}`);
    default:
      return tCommon(`size_display_converter.${sizeType}.${size}`);
  }
}
